import { render, staticRenderFns } from "./cdxxgcdx.vue?vue&type=template&id=198c4334&scoped=true&"
import script from "./cdxxgcdx.vue?vue&type=script&lang=js&"
export * from "./cdxxgcdx.vue?vue&type=script&lang=js&"
import style0 from "./cdxxgcdx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdxxgcdx.vue?vue&type=style&index=1&id=198c4334&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c4334",
  null
  
)

export default component.exports